import { Injectable } from "@angular/core";
import Chart from "chart.js/auto";
import "chartjs-adapter-moment";

@Injectable({
    providedIn: "root",
})
export class ChartService {
    accentColors: { [key: string]: string } = {
        plum: "rgba(137, 12, 88, 0.8)",
        amber: "rgb(242, 172, 51)",
        turquoise: "rgb(0, 172, 168)",
        violet: "rgba(58, 57, 123, 0.8)",
        seablue: "rgb(0, 112, 150)",
        lime: "rgb(180, 212, 5)",
        cerise: "rgb(189, 47, 127)",
        silver: "rgb(181, 181, 181)",
        grey: "rgb(204, 204, 204)",
        bright_blue: "rgb(0, 150, 255)",
        sea_blue_background: "rgba(0, 150, 255, 0.3)",
        dark_blue: "rgb(0,0,139)",
    };

    public destroyOldChart(chart: any) {
        if (chart && chart != null) {
            chart.destroy();
        }
    }

    populateTop5CategoriesByVolumeChart(chartData: any[], chartInstance: any) {
        this.destroyOldChart(chartInstance);
        let ctx = document.getElementById("top5CategoriesByVolume");
        let chartOptions = this.getHorizontalBarChartOptions(
            "# of queries / hits",
            null,
            false,
        );
        chartOptions.scales.x.ticks = {
            callback: function (value) {
                return value < 1000000
                    ? value / 1000 + "K"
                    : value / 1000000 + "M";
            },
        };
        return this.renderBarChart2(ctx, chartData, chartOptions, [
            this.accentColors.dark_blue,
        ]);
    }

    populatetop5SitesUsingUDFChart(chartData: any[], chartInstance: any) {
        this.destroyOldChart(chartInstance);
        let ctx = document.getElementById("top5SitesUsingUDF");
        let chartOptions = this.getLineChartOptions(
            null,
            "# of queries / hits",
        );
        chartOptions.scales.x.ticks.maxTicksLimit = 5;
        chartOptions.scales.y.ticks = {
            callback: function (value) {
                return value < 1000000
                    ? value / 1000 + "K"
                    : value / 1000000 + "M";
            },
        };
        return this.renderLineChart(
            (ctx = ctx),
            (chartData = chartData),
            (chartOptions = chartOptions),
            false,
        );
    }

    populatetop5OrgsUsingUDFChart(chartData: any[], chartInstance: any) {
        this.destroyOldChart(chartInstance);
        let ctx = document.getElementById("top5OrgsUsingUDF");
        let backBtn = document.getElementById("backBtn");
        let chartOptions = this.getBarChartOptions(
            null,
            "# of queries / hits",
            false,
        );
        chartOptions.scales.y.ticks = {
            callback: function (value) {
                return value < 1000000
                    ? value / 1000 + "K"
                    : value / 1000000 + "M";
            },
        };
        chartOptions.parsing = {
            xAxisKey: "ASSET",
            yAxisKey: "QUERIES",
        };

        let myChartInstance = this.renderBarChart2(
            ctx,
            chartData,
            chartOptions,
            [this.accentColors.bright_blue],
        );

        chartOptions.onHover = (event, chartElement) => {
            this.onChartHover(event, chartElement, myChartInstance);
        };

        ctx.onclick = (s: any) => {
            this.onChartClick(s, myChartInstance, chartData, backBtn);
        };

        // myChartInstance.ctx.textAlign = "center";
        // myChartInstance.ctx.textBaseline = "bottom";

        // this.datasets.forEach(function (dataset) {
        //     dataset.bars.forEach(function (bar) {
        //         ctx.fillText(bar.value, bar.x, bar.y - 5);
        //     });
        // })

        return myChartInstance;
    }

    populateQueryByBUUsingUDFChart(chartData: any[], chartInstance: any) {
        this.destroyOldChart(chartInstance);
        let ctx: any = document.getElementById("topQueriesByBU");
        let chartOptions = this.getPieChartOptions();
        const data = {
            labels: chartData.map((x) => x.BUSINESS_UNITS),
            datasets: [
                {
                    label: "# of queries / hits",
                    data: chartData.map((x) => x.QUERIES),
                    backgroundColor: Object.keys(this.accentColors).map(
                        (key) => this.accentColors[key],
                    ),
                    hoverOffset: 5,
                    rotation: 60,
                    //   cutout:'10%',
                    //   borderRadius:30,
                    //   offset:10
                },
            ],
        };

        const pieLabelsLine = {
            id: "pieLabelsLine",
            afterDraw(chart) {
                const {
                    ctx,
                    chartArea: { width, height },
                } = chart;

                const cx = chart._metasets[0].data[0].x;
                const cy = chart._metasets[0].data[0].y;
                var meta = chart.getDatasetMeta(0);

                // var view = meta.view;
                var labels = chart.config.data.labels;
                var center = meta.data[0];

                const sum = chart.data.datasets[0].data.reduce(
                    (a, b) => a + b,
                    0,
                );

                chart.data.datasets.forEach((dataset, i) => {
                    //console.log(chart.getDatasetMeta(i))
                    chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
                        const { x: a, y: b } = datapoint.tooltipPosition();

                        const x = 2 * a - cx;
                        const y = 2 * b - cy;

                        // draw line
                        const halfwidth = width / 2;
                        const halfheight = height / 2;
                        const xLine = x >= halfwidth ? x + 5 : x - 5;
                        const yLine = y >= halfheight ? y + 5 : y - 5;

                        const extraLine = x >= halfwidth ? 5 : -5;

                        ctx.beginPath();
                        ctx.moveTo(x, y);
                        ctx.arc(x, y, 2, 0, 2 * Math.PI, true);
                        ctx.fill();
                        ctx.moveTo(x, y);
                        ctx.lineTo(xLine, yLine);
                        ctx.lineTo(xLine + extraLine, yLine);
                        // ctx.strokeStyle = dataset.backgroundColor[index];
                        ctx.strokeStyle = "black";
                        ctx.stroke();

                        // text
                        const textWidth = ctx.measureText(
                            chart.data.labels[index],
                        ).width;
                        ctx.font = "500 9px Arial";
                        // control the position
                        const textXPosition = x >= halfwidth ? "left" : "right";
                        const plusFivePx = x >= halfwidth ? 5 : -5;
                        ctx.textAlign = textXPosition;
                        ctx.textBaseline = "middle";
                        // ctx.fillStyle = dataset.backgroundColor[index];
                        ctx.fillStyle = "black";
                        ctx.fillText(
                            (
                                (chart.data.datasets[0].data[index] * 100) /
                                sum
                            ).toFixed(2) + "%",
                            xLine + extraLine + plusFivePx,
                            yLine,
                        );
                    });
                });
            },
        };

        const customText = "*This data excludes IT queries";

        const pieNote = {
            id: "pieNote",
            afterDraw(chart) {
                const ctx = chart.ctx;
                const canvas = chart.canvas;
                const textWidth = ctx.measureText(customText).width;
                //  const textX = canvas.width - (canvas.width*2/100);
                //  const textY = canvas.height - (canvas.width*1/100);

                const textX = canvas.width - 6;
                const textY = canvas.height - 6;

                ctx.restore();
                ctx.font = "500 12px Roboto";
                ctx.fillStyle = "black";
                ctx.textAlign = "end";
                ctx.fillText(customText, textX, textY);
                ctx.save();
            },
        };

        return this.renderPieChart(ctx, data, chartOptions, [pieLabelsLine]);
    }

    onChartHover(event, chartElement, myChartInstance) {
        if (myChartInstance.config.data.datasets[0].data[0].detailedData) {
            event.native.target.style.cursor = chartElement[0]
                ? "pointer"
                : "default";
        } else {
            event.native.target.style.cursor = "default";
        }
    }

    onChartClick(click, myChartInstance, chartData, backBtn: HTMLElement) {
        if (myChartInstance.config.data.datasets[0].data[0].detailedData) {
            const bar = myChartInstance.getElementsAtEventForMode(
                click,
                "nearest",
                { intersect: true },
                true,
            );
            if (bar.length) {
                this.updateChart(bar[0].index, myChartInstance, chartData);
            }
        }
    }

    updateChart(index, myChartInstance, chartData) {
        const vColor = [];
        chartData[index].detailedData.forEach((element) => {
            vColor.push(
                this.accentColors[Object.keys(this.accentColors)[index]],
            );
        });
        myChartInstance.config.data.datasets[0].data =
            chartData[index].detailedData;
        myChartInstance.config.data.datasets[0].backgroundColor = vColor;
        myChartInstance.update();
    }

    populateAverageQueryTimeChart(chartData: any[], chartInstance: any) {
        this.destroyOldChart(chartInstance);

        let ctx = document.getElementById("avgQueryTime");
        let chartOptions = this.getLineChartOptions(null, null);
        chartOptions.scales.x.time = this.getTimeConfig();
        chartOptions.scales.x.ticks.maxTicksLimit = 5;
        return this.renderLineChart(ctx, chartData, chartOptions);
    }

    getTimeConfig() {
        return {
            tooltipFormat: "yyy-MM-DD",
        };
    }

    getLineChartOptions(xAxisLabel: string, yAxisLabel: string): any {
        return {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1,
            // layout: {
            // height: "500px",
            // padding:{
            //     top:20
            // }
            // },
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        autoSkip: false,
                        beginAtZero: false,
                        maxTicksLimit: 10,
                        maxRotation: 0,
                        minRotation: 0,
                    },
                    title: {
                        display: xAxisLabel != null ? true : false,
                        text: xAxisLabel,
                        font: { weight: "bold" },
                    },
                },
                y: {
                    grid: {
                        display: true,
                    },
                    title: {
                        display: yAxisLabel != null ? true : false,
                        text: yAxisLabel != null ? yAxisLabel : "",
                        font: { weight: "bold" },
                    },
                    ticks: {
                        beginAtZero: true,
                    },
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    intersect: false,
                },
            },
        };
    }

    getBarChartOptions(
        xAxisLabel: string,
        yAxisLabel: string,
        isStacked: boolean = false,
    ): any {
        return {
            responsive: true,
            indexAxis: "x",
            maintainAspectRatio: false,
            aspectRatio: 2.5,
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
            },
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    scaleLabel: {
                        display: false,
                    },
                    ticks: {
                        autoSkip: false,
                        maxTicksLimit: 5,
                        maxRotation: 0,
                        minRotation: 0,
                    },
                    title: {
                        display: xAxisLabel != null ? true : false,
                        text: xAxisLabel,
                        font: { weight: "bold" },
                    },
                    stacked: isStacked,
                },
                y: {
                    grid: {
                        display: true,
                    },
                    beginAtZero: true,
                    scaleLabel: {
                        display: false,
                    },
                    ticks: {
                        display: true,
                    },
                    title: {
                        display: yAxisLabel != null ? true : false,
                        text: yAxisLabel,
                        font: { weight: "bold" },
                    },
                    stacked: isStacked,
                },
            },
            plugins: {
                legend: {
                    display: isStacked,
                    align: "start",
                    labels: {
                        usePointStyle: true,
                        boxWidth: 6,
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: "point",
                },
            },
        };
    }

    getHorizontalBarChartOptions(
        xAxisLabel: string,
        yAxisLabel: string,
        isStacked: boolean = false,
    ): any {
        return {
            // responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 2.5,
            indexAxis: "y",
            layout: {
                width: "100%",
                height: "100%",
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                },
            },
            scales: {
                y: {
                    grid: {
                        display: false,
                    },
                    scaleLabel: {
                        display: false,
                    },
                    ticks: {
                        autoSkip: false,
                        beginAtZero: false,
                        maxTicksLimit: 5,
                        maxRotation: 0,
                        minRotation: 0,
                    },
                    title: {
                        display: yAxisLabel != null ? true : false,
                        text: yAxisLabel,
                        font: { weight: "bold" },
                    },
                    stacked: isStacked,
                },
                x: {
                    grid: {
                        display: true,
                    },
                    beginAtZero: false,
                    scaleLabel: {
                        display: false,
                    },
                    ticks: {
                        display: true,
                    },
                    title: {
                        display: xAxisLabel != null ? true : false,
                        text: xAxisLabel,
                        font: { weight: "bold" },
                    },
                    stacked: isStacked,
                },
            },
            plugins: {
                legend: {
                    display: isStacked,
                    align: "start",
                    labels: {
                        usePointStyle: true,
                        boxWidth: 6,
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: "y",
                },
            },
        };
    }
    getPieChartOptions(): any {
        return {
            rotation: 0.1 * Math.PI,
            maintainAspectRatio: false,
            aspectRatio: 2.5,
            radius: "70%",
            layout: {
                padding: {
                    // top: 15,
                    // bottom:15,
                    left: 25,
                    right: 5,
                },
            },
            plugins: {
                legend: {
                    display: true,
                    position: "right",
                    layout: {
                        // minWidth: '10px',
                    },
                    labels: {
                        usePointStyle: true,
                        // pointStyleWidth: 10,
                        font: {
                            size: 9,
                        },
                    },
                },
            },
        };
    }

    renderLineChart(
        ctx: any,
        chartData: any,
        chartOptions: any,
        skipPoints: boolean = true,
    ) {
        return new Chart(ctx, {
            type: "line",
            data: {
                datasets: [
                    {
                        label: "# of queries / hits",
                        data: chartData,
                        showLine: true,
                        //lineTension: 0,
                        pointRadius: skipPoints ? 0 : 2,
                        pointHoverRadius: 5,
                        pointBackgroundColor: this.accentColors.bright_blue,
                        fill: true,
                        backgroundColor: this.accentColors.sea_blue_background,
                        borderColor: this.accentColors.bright_blue,
                        borderWidth: 2,
                    },
                ],
            },
            options: chartOptions,
        });
    }

    renderBarChart2(
        ctx: any,
        chartData: any[],
        chartOptions: any,
        barColor: string[],
    ) {
        return new Chart(ctx, {
            type: "bar",
            data: {
                datasets: [
                    {
                        label: "# of queries / hits",
                        data: chartData,
                        barPercentage: 1,
                        backgroundColor: barColor,
                    },
                ],
            },
            options: chartOptions,
        });
    }

    renderPieChart(
        ctx: any,
        chartData: any,
        chartOptions: any,
        customplugin: any[],
    ) {
        Chart.defaults.font.size = 11;
        return new Chart(ctx, {
            type: "pie",
            data: chartData,
            options: chartOptions,
            plugins: customplugin,
        });
    }
}
